import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const IconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
`;
export const Container = styled.div `
  height: ${pxToRem(32)};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeGet('spacing.sm')};
  padding: ${themeGet('spacing.sm')};
  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  border-radius: ${themeGet('borderRadius.md')};
  transition: box-shadow 175ms ease-in-out;
  box-shadow: none;

  &:focus-within {
    outline: none;
    box-shadow: 0 0 0 ${pxToRem(2)} ${themeGet('colors.focus.primary')};
  }
`;
export const StyledInput = styled.input `
  padding: 0;
  border: none;
  outline: none;
  height: inherit;
  background-color: transparent;
  color: ${themeGet('colors.text.300')};
  font-size: ${themeGet('fontSize.medium')};
`;
